import React, { useCallback, useEffect, useRef, useState } from "react";
import "./Header.scss";
import {
  IoBookOutline,
  IoSearchOutline,
  IoCloseCircleOutline,
  IoExitOutline,
  IoPersonSharp
} from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { Songbook } from "../../../@core/models";
import { Auth } from "../../../@core/auth";
import debounce from "lodash/debounce";
import RestClient from "../../../@core/restClient";
import Spinner from "../../widgets/UI/Spinner";
//import LoginModal from "../dynamic/LoginModal/LoginModal";

type queryState = [query: string, setQuery: (query: string) => void];

type SelectedSongbookIdState = [
  selectedSongbookId: number | null,
  setSelectedSongbookId: (selectedSongbookId: number | null) => void
];

type SongbooksState = [
  songbooks: Songbook[],
  setSongbooks: (songbooks: Songbook[]) => void
];

type IsOpenState = [isOpen: boolean, setIsOpen: (isOpen: boolean) => void];

const Header = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const queryRef = useRef<any>();
  const [query, setQuery]: queryState = useState<string>("");
  const [selectedSongbookId, setSelectedSongbookId]: SelectedSongbookIdState =
    useState<number | null>(null);
  const [songbooks, setSongbooks]: SongbooksState = useState<Songbook[]>([]);
  const [isOpen, setIsOpen]: IsOpenState = useState(false);
  const navigate = useNavigate();
  //const [loginModalShow, setLoginModalShow] = useState(false);
  const [person, setPerson] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // CHEKING AUTHENTICATION ON LOAD AND ON VISIBILITY CHANGE
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        if (Auth.isAuthenticated) {
          setPerson(true);
        } else {
          setPerson(false);
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  // CHECK AUTHENTICATION ON MOUNT
  useEffect(
    function () {
      if (Auth.isAuthenticated) {
        setPerson(true);
      } else {
        setPerson(false);
      }
    },
    [localStorage.getItem("User")]
  );
  //CHEKING AUTHENTICATION EVERY 30 MIN

  useEffect(() => {
    const interval = setInterval(() => {
      if (Auth.isAuthenticated) {
        setPerson(true);
      } else {
        setPerson(false);
      }
    }, 30 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const goHome = () => {
    //queryRef.current.value = "";
    //setQuery("");
    //setSelectedSongbookId(null);
    //setSongbooks([]);
    setIsOpen(false);
    navigate("/");
  };

  const deferredSetQueryHandler = useCallback(
    debounce((event: React.ChangeEvent<HTMLInputElement>) => {
      setQuery(event.target.value);
    }, 500),
    []
  );

  useEffect(
    function () {
      (async () => {
        if (
          queryRef.current !== document.activeElement ||
          queryRef.current.value !== query
        ) {
          return;
        }
        try {
          setIsLoading(true);
          const response = await RestClient.getSongbookList(query);
          setSongbooks(response || []);
        } catch (error) {
          console.log(error);
        }
        setIsLoading(false);
      })();
    },
    [query, isOpen]
  );

  const selectSongbook = (songbook: Songbook) => {
    queryRef.current.value = songbook.title;
    setQuery(songbook.title);
    setSelectedSongbookId(songbook.id);
    setSongbooks([]);
    navigate(`/songbook/${songbook.id}`);
    setQuery("");
    setIsOpen(false);
  };

  const openAgain = (e: any) => {
    e.stopPropagation();
    queryRef.current.value = "";
    //setQuery("");
    //setSelectedSongbookId(null);
    setIsOpen(true);
  };
  const goToCabinet = () => {
    navigate("/cabinet");
  };

  useEffect(() => {
    if (isOpen) {
      document.body.addEventListener("click", () => {
        setIsOpen(false);
      });
    } else {
      return;
    }
  }, [isOpen]);

  return (
    <header className="row">
      <div className="col-6 col-lg-3 mb-3">
        <div className="d-flex align-items-center">
          <a onClick={goHome}>
            <img
              src="/images/header-logo.png"
              className="img-logo"
              alt="logo"
            />
          </a>
          <div className="text-logo">
            <p className="title text-uppercase">Aryn-lyrics</p>
            <p className="sub-title">Твій збірник пісень</p>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-6 order-3 order-lg-2 mb-3">
        <div className="h-100 d-flex align-items-center">
          <div className="songbook-input-container">
            <div className="songbook-input-container-spinner">
              {isLoading ? <Spinner /> : ""}
            </div>
            {/* <input
              type="text"
              ref={queryRef}
              className="songbook-input"
              placeholder="Введіть назву збірника.."
              //onFocus={() => setIsOpen(true)}
              onChange={deferredSetQueryHandler}
              onClick={(e) => openAgain(e)}
            />
            <IoSearchOutline className="search" /> */}

            {songbooks?.length > 0 && isOpen && (
              <div className="select-container">
                <IoCloseCircleOutline
                  className="close"
                  onClick={() => setIsOpen(false)}
                />
                {songbooks?.map((songbook: Songbook, index: number) => (
                  <div
                    className="select-item"
                    key={index}
                    onClick={() => selectSongbook(songbook)}
                  >
                    {songbook.title}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="col-6 col-lg-3 order-2 order-lg-3 mb-3">
        <div className="h-100 d-flex justify-content-end align-items-center">
          <div className="manual-tooltip">
            <IoBookOutline
              className="manual-icon"
              onClick={() => navigate("/manual")}
            />
            <span className="manual-tooltip-text">Мануал</span>
          </div>
          {!person ? (
            <button
              className="signIn btn-plain"
              onClick={() => navigate("/loginmodal")}
            >
              Увійти
            </button>
          ) : (
            <div className="logedIn">
              <div className="login-box">
                <div className="login-box-tooltip">
                  <button className="login" onClick={goToCabinet}>
                    <IoPersonSharp className="login-icon" />
                  </button>
                  <span className="login-box-tooltip-text">Кабінет</span>
                </div>
                <div
                  className="user-email"
                  onClick={() => navigate("/loginmodal")}
                >
                  <div>
                    {
                      JSON.parse(localStorage.getItem("User") || "{}")
                        ?.firstName
                    }
                  </div>
                  <div>
                    {JSON.parse(localStorage.getItem("User") || "{}")?.lastName}
                  </div>
                </div>
              </div>
              <div className="exit-tooltip">
                <IoExitOutline
                  className="exit"
                  onClick={() => {
                    localStorage.removeItem("User");
                    localStorage.removeItem("Token");
                    setPerson(false);
                    goHome();
                  }}
                />
                <span className="exit-tooltip-text">Вийти</span>
              </div>
            </div>
          )}
        </div>
        {/* {loginModalShow ?
          <div>
            <LoginModal closeModal={closeLoginModal} />
          </div> : null
        } */}
      </div>
    </header>
  );
};

export default Header;
